<script setup lang="ts">
import { SOUND_CATEGORIES, type SoundCategory } from '@ddt/game-engine';
import { DdtButton, DdtModal, DdtVolumeSlider } from '@ddt/ui';
import { audio, mixer, mixerOpen, resetMixer } from '../audio';

/** Janela do mixer: volume geral e uma barra por tipo de som (música, combate, interface, movimento, turno e fim). */
function setVolume(category: SoundCategory, value: number) {
  audio.setChannelVolume(category, value);
}
</script>

<template>
  <DdtModal :open="mixerOpen" title="Mixer de som" @close="mixerOpen = false">
    <div class="stack" data-testid="mixer">
      <DdtVolumeSlider
        label="Geral"
        hint="Controla todos os sons"
        :model-value="mixer.master.volume"
        :muted="mixer.master.muted"
        data-testid="mixer-master"
        @update:model-value="audio.setMasterVolume($event)"
        @update:muted="audio.setMasterMuted($event)"
      />
      <hr style="border: 0; border-top: 1px solid var(--ddt-border); width: 100%" />
      <DdtVolumeSlider
        v-for="c in SOUND_CATEGORIES"
        :key="c.id"
        :label="c.label"
        :hint="c.hint"
        :model-value="mixer.channels[c.id].volume"
        :muted="mixer.channels[c.id].muted"
        :data-testid="`mixer-${c.id}`"
        @update:model-value="setVolume(c.id, $event)"
        @update:muted="audio.setChannelMuted(c.id, $event)"
        @commit="audio.preview(c.id)"
      />
    </div>
    <template #footer>
      <div class="row" style="justify-content: space-between">
        <DdtButton variant="ghost" size="sm" data-testid="mixer-reset" @click="resetMixer">Restaurar padrão</DdtButton>
        <DdtButton size="sm" @click="mixerOpen = false">Fechar</DdtButton>
      </div>
    </template>
  </DdtModal>
</template>
